import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ErrorService implements ErrorHandler {
  constructor(private injector: Injector, private translateService: TranslateService) { }

  handleError(error: any) {
    const router = this.injector.get(Router);
    const toastr = this.injector.get(ToastrService);

    if (error instanceof HttpErrorResponse) {
      if (error.status === 400) {
        let validationErrors = error.error?.Errors;
        let messages = validationErrors ?
          validationErrors.map((e: any) => e.In?.length > 0
            ? (validationErrors[0].In as { Name: string, Type: string, Reason: string }[])
            : [{ Name: this.translateService.instant('toastr.error.title'), Reason: e.Detail }]
          ).reduce((a: any[], b: any[]) => a.concat(b)) : null;
        if (messages?.length > 0) {
          messages.forEach((m: any) => {
            toastr.error(m.Reason, m.Name);
          });
        }
        else
          toastr.error(
            this.translateService.instant('toastr.error.message'),
            this.translateService.instant('toastr.error.title'));
      } else if (error.status === 401) {
        const authService = this.injector.get(AuthService);

        // Both targets used to be routes that do not exist ('error/404', 'login'), so every 401
        // fell through the wildcard route and landed the user on the 404 page.
        if (authService.isAuthenticated()) router.navigate(['/404']);
        else router.navigate(['/join/login']);
      } else {
        toastr.error(this.translateService.instant('toastr.error.message'),
          this.translateService.instant('toastr.error.title'));
      }
    }
    if ((error.message as string).indexOf('ExpressionChangedAfterItHasBeenCheckedErro') === -1) console.error(error);

    // router.navigate(['error/404']);
  }
}
